const motAutorizadorMenu = {
    label: 'Temporário',
    icon: 'pi pi-briefcase',
    to: '/autorizadorfinanceiro/mao-de-obra-temporaria',
    matchChildren: true,
    rules: ['AUTORIZADOR-MOT-00'],
};

export { motAutorizadorMenu };
